

export const SocialData = [
    {
        platform: "linkedin",
        link:"https://www.linkedin.com/in/prince-kumar-3451a11ba/",
        icon: require("../../assets/icons/linkedin.png")
    },
    {
        platform: "github",
        link:"https://github.com/prince-111",
        icon: require("../../assets/icons/github.png")
    },
    {
        platform: "Email",
        link:"mailto: princesd991@gmail.com",
        icon: require("../../assets/icons/email.png")
    },
    // {
    //     platform: "medium",
    //     link:"",
    //     icon: require("../../assets/icons/medium.png")
    // },
    // {
    //     platform: "instagram",
    //     link:"",
    //     icon: require("../../assets/icons/instagram.png")
    // },
    // {
    //     platform: "facebook",
    //     link:"",
    //     icon: require("../../assets/icons/facebook.png")
    // },
];